import {
  addCompany,
  removeCompany,
  setCompanies,
  updateCompany,
} from './companyActions'
import { Constants } from './companyConstants'
import { Company } from '../../../model/company.model'

type Actions =
  | ReturnType<typeof setCompanies>
  | ReturnType<typeof addCompany>
  | ReturnType<typeof updateCompany>
  | ReturnType<typeof removeCompany>

export const companyReducer = (state: Company[] = [], action: Actions) => {
  switch (action.type) {
    case Constants.SET_COMPANIES:
      return action.payload
    case Constants.ADD_COMPANY:
      return [...state, action.payload]

    case Constants.UPDATE_COMPANY:
      return state.map((company) => {
        // if id does not match, return non changed item
        if (company.company_id !== action.payload.company_id) {
          return company
        }

        // replace with the updated item
        return {
          ...company,
          ...action.payload,
        }
      })
    case Constants.REMOVE_COMPANY:
      return state.filter(
        (company: Company) => company?.company_id !== action.payload
      )
    default:
      return state
  }
}